export enum ProfessionCodeEnum {
    RN = 1,
    Physician = 59
}
